import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import PortalHub from "@/pages/PortalHub";
import Layout from "@/components/Layout";
import CommercialDashboard from "@/pages/CommercialDashboard";
import Campaigns from "@/pages/Campaigns";
import Beneficiaries from "@/pages/Beneficiaries";
import Expenses from "@/pages/Expenses";
import Revenues from "@/pages/Revenues";
import Income from "@/pages/Income";
import CharityDashboard from "@/pages/CharityDashboard";
import CharityBeneficiaries from "@/pages/CharityBeneficiaries";
import CharityReports from "@/pages/CharityReports";
import Settings from "@/pages/Settings";
import Blacklist from "@/pages/Blacklist";
import PrintPage from "@/pages/PrintPage";
import PublicRegistration from "@/pages/PublicRegistration";
import RatingPage from "@/pages/RatingPage";
import VoucherPrint from "@/pages/VoucherPrint";
import TicketPage from "@/pages/TicketPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-emerald-900">
        جارٍ التحميل...
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppInner() {
  useEffect(() => {
    document.documentElement.setAttribute("dir", "rtl");
    document.documentElement.setAttribute("lang", "ar");
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/register/:token" element={<PublicRegistration />} />
        <Route path="/rate/:token" element={<RatingPage />} />
        <Route path="/ticket/:token" element={<TicketPage />} />
        <Route path="/voucher/:id" element={<Protected><VoucherPrint /></Protected>} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <Protected>
              <PortalHub />
            </Protected>
          }
        />
        <Route
          path="/commercial"
          element={
            <Protected>
              <Layout portal="commercial" />
            </Protected>
          }
        >
          <Route index element={<CommercialDashboard />} />
          <Route path="campaigns" element={<Campaigns portal="commercial" />} />
          <Route path="beneficiaries" element={<Beneficiaries />} />
          <Route path="expenses" element={<Expenses />} />
          <Route path="revenues" element={<Revenues />} />
          <Route path="income" element={<Income />} />
        </Route>
        <Route
          path="/charitable"
          element={
            <Protected>
              <Layout portal="charitable" />
            </Protected>
          }
        >
          <Route index element={<CharityDashboard />} />
          <Route path="campaigns" element={<Campaigns portal="charitable" />} />
          <Route path="beneficiaries" element={<CharityBeneficiaries />} />
          <Route path="reports" element={<CharityReports />} />
        </Route>
        <Route
          path="/settings"
          element={
            <Protected>
              <Settings />
            </Protected>
          }
        />
        <Route
          path="/blacklist"
          element={
            <Protected>
              <Blacklist />
            </Protected>
          }
        />
        <Route path="/print/:portal/:kind" element={<Protected><PrintPage /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
